// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39rYi","content":"styles_content__3_Clo"};